import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class ProductDesignService {
  url :string = environment.url;

  private readonly _productDesigns = new BehaviorSubject<any>(<any>[]);
  public productDesigns$ = this._productDesigns.asObservable();

  public gettingRecords :boolean = false;

  constructor(private http :HttpClient) {}

  get(params) {
    this.gettingRecords = true;

    return this.http
      .get(`${this.url}/product_designs`, { params: params })
      .subscribe((resp :any) => {
        if (resp.data && resp.data.length > 0) {
          // resp.data.forEach((row: any) => {
          // 	row.links = JSON.parse(row.links);
          // 	row.attachments = JSON.parse(row.attachments);
          // })
        } else if (params.page && params.page == 1) {
          resp = { data: [] };
        }
        this.gettingRecords = false;
        this._productDesigns.next(resp);
      });
  }

  getAsync(params :any) :Observable<any> {
    return this.http.get(`${this.url}/product_designs`, { params: params });
  }

  search(params :any) :Observable<any> {
    return this.http.get(`${this.url}/product_designs-search`, {
      params: params,
    });
  }

  getById(designId :number) :Observable<any> {
    return this.http.get(`${this.url}/product_designs/${designId}`);
  }

  updateproductDesign(designId :number, payload :any) :Observable<any> {
    return this.http.post(`${this.url}/product_designs/${designId}`, payload).pipe(
      tap((resp :any) => {
        this.tryUpdateOrAddResp(resp);
      }),
    );
  }

  markAsCompleted(designId :number, payload :any) :Observable<any> {
    return this.http
      .post(`${this.url}/product_designs/${designId}/mark-as-completed`, payload)
      .pipe(
        tap((resp :any) => {
          this.tryUpdateOrAddResp(resp);
        }),
      );
  }

  createproductDesign(payload :any) :Observable<any> {
    return this.http.post(`${this.url}/product_designs`, payload).pipe(
      tap((resp :any) => {
        this.tryUpdateOrAddResp(resp);
      }),
    );
  }

  deleteproductDesign(designId :number) {
    return this.http.delete(`${this.url}/product_designs/${designId}`).pipe(
      tap((resp :any) => {
        const product_designs :any = this._productDesigns.getValue();
        if (product_designs.data && product_designs.data.length) {
          const poIdx = product_designs.data.findIndex((row) => row.id == designId);
          product_designs.data.splice(poIdx, 1);
        }
        this._productDesigns.next(product_designs);
      }),
    );
  }

  deleteproductDesignPipeline(designId :number) {
    return this.http.delete(`${this.url}/product_designs/${designId}`);
  }

  tryUpdateOrAddResp(resp :any) {
    const product_designs :any = this._productDesigns.getValue();

    if (!product_designs || !product_designs.data) {
      return;
    }
    const poIdx = product_designs.data.findIndex((row) => row.id == resp.id);
    if (poIdx >= 0) {
      product_designs.data[poIdx] = resp;
    } else {
      product_designs.data.splice(0, 0, resp);
    }

    this._productDesigns.next(product_designs);
  }

  updatePipelineStatus(designId :number, status :string) :Observable<any> {
    return this.http.post(
      `${this.url}/product_designs/${designId}/pipeline_status`,
      {
        pipeline_status: status,
      },
    );
  }

  getDesignPipelines(designId :number) {
    return this.http.get(`${this.url}/product_designs/${designId}/pipelines`, {});
  }

  setDesignPipelines(designId :number, payload :any) {
    return this.http
      .post(`${this.url}/product_designs/${designId}/pipelines`, payload)
      .pipe(
        tap((data :any) => {
          if (designId > 0) {
            const record = this._productDesigns.getValue();
            if (record && record.data && record.data.length > 0) {
              const idx = record.data.findIndex((row) => {
                return row.id == designId;
              });
              if (idx || idx >= 0) {
                record.data[idx].pipelines = payload.pipelines;
                this._productDesigns.next(record);
              }
            }
          }
        }),
      );
  }

  updateDesignPipelineStage(designId :number, pipelineId :any, payload :any) {
    return this.http.post(
      `${this.url}/product_designs/${designId}/pipelines/${pipelineId}`,
      payload,
    );
  }

  saveSubtask(designId :number, payload :any) :Observable<any> {
    return this.http
      .post(`${this.url}/product_designs/${designId}/save-subtask`, payload)
      .pipe(
        tap((resp :any) => {
          this.tryUpdateOrAddResp(resp);
        }),
      );
  }

  deleteSubtask(designId :number, payload :any) :Observable<any> {
    return this.http
      .post(`${this.url}/product_designs/${designId}/delete-subtask`, payload)
      .pipe(
        tap((resp :any) => {
          this.tryUpdateOrAddResp(resp);
        }),
      );
  }

  saveComment(designId :number, payload :any) :Observable<any> {
    return this.http
      .post(`${this.url}/product_designs/${designId}/save-comment`, payload)
      .pipe(
        tap((resp :any) => {
          this.tryUpdateOrAddResp(resp);
        }),
      );
  }

  deleteComment(designId :number, payload :any) :Observable<any> {
    return this.http
      .post(`${this.url}/product_designs/${designId}/delete-comment`, payload)
      .pipe(
        tap((resp :any) => {
          this.tryUpdateOrAddResp(resp);
        }),
      );
  }

  deleteAttachment(designId :number, payload :any) :Observable<any> {
    return this.http
      .post(
        `${this.url}/product_designs/${designId}/delete-comment-attachment`,
        payload,
      )
      .pipe(
        tap((resp :any) => {
          this.tryUpdateOrAddResp(resp);
        }),
      );
  }

  toggleCheckSubtask(designId :number, payload :any) :Observable<any> {
    return this.http
      .post(`${this.url}/product_designs/${designId}/toggle-check-subtask`, payload)
      .pipe(
        tap((resp :any) => {
          this.tryUpdateOrAddResp(resp);
        }),
      );
  }

  updateLinkedModules(designId :number, payload :any) :Observable<any> {
    return this.http.post(`${this.url}/product_designs/${designId}/link-modules`, {
      linked_modules: payload,
    });
  }

  bulkUpdate(payload :any) {
    // product_designs_bulk_update
    return this.http.post(`${this.url}/product_designs_bulk_update`, payload).pipe(
      tap((resp :any) => {
        resp.designSKUs.forEach((design) => {
          this.tryUpdateOrAddResp(design);
        });
      }),
    );
  }
}
